<div style="width: 100px;">
    <div [id]="elementIdDynamic" [class]="testSealClass" data-language="en"></div>
</div>